import { Box, OSKIcon, Spinner, Table, TableColumn, Text } from 'oskcomponents';
import { noop } from 'oskcore';
import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '~/redux/store';
import { AssetDetection, selectDetectionsByAssetByPage } from '~/redux/modules/monitor/app';
import { date_format, getProgramId } from '~/utils';
import { useNavigate } from 'react-router-dom';

type AssetDetectionsTableProps = {
    /** The currently selected assetId */
    selectedAssetId?: number;
    /** The detection to populate the table with */
    data: Array<AssetDetection>;
    /** Whether or not to display the visibility checkbox column */
    showVisibilityFilters: boolean;
    /** The status of loading detections */
    fetchingDetections: boolean;
    /** Whether or not to show the map deep link button */
    showMapLinkButton: boolean;
};

const AssetDetectionsTable = ({ data, showMapLinkButton, fetchingDetections, ...props }: AssetDetectionsTableProps) => {
    const navigate = useNavigate();
    const columns = React.useMemo<Array<TableColumn>>(
        () => [
            { Header: 'Id', accessor: 'id' },
            {
                Header: 'Type',
                accessor: 'call_type',
            },
            {
                Header: 'Detection Type',
                accessor: 'detection_type',
            },
            {
                Header: 'Date',
                accessor: 'detected_at',
                Cell: ({ value }: any) => {
                    const date = date_format(value);
                    return date ? date : '--';
                },
            },
            ...(showMapLinkButton
                ? [
                      {
                          Header: '',
                          accessor: 'deeplink',
                          disableSortBy: true,
                          Cell: ({ row }: any) => {
                              const { asset, id } = row.original;
                              const mapLink = `/program/${getProgramId()}/monitor/${asset}/map/alert/${id}`;

                              return <OSKIcon code="map" onClick={() => navigate(mapLink)} />;
                          },
                      },
                  ]
                : []),
        ],
        [],
    );

    if (fetchingDetections) {
        return (
            <Box center="all" grow style={{ alignSelf: 'center' }}>
                <Spinner />
            </Box>
        );
    }

    if (data.length < 1) {
        return (
            <Box grow center="all" style={{ alignSelf: 'center' }}>
                <Text>No detections available</Text>
            </Box>
        );
    }

    return (
        <Box style={{ flexShrink: 1 }} col grow>
            <Table {...props} columns={columns} data={data} />
        </Box>
    );
};

const mapStateToProps = (state: RootState, ownProps: Partial<AssetDetectionsTableProps>) => {
    const { selectedAssetId } = ownProps;

    return {
        data: selectDetectionsByAssetByPage(state, selectedAssetId ?? -1),
        fetchingDetections: state.monitor.app.fetchingAllDetections,
    };
};

const ConnectedAssetDetectionsTable = connect(mapStateToProps, noop)(AssetDetectionsTable);
export default ConnectedAssetDetectionsTable;
export { ConnectedAssetDetectionsTable as AssetDetectionsTable };
export type { AssetDetectionsTableProps };
